import { Slide1, Slide2, Slide3 } from '@/components/history';
import { HistoryLoading } from '@/components/history';
import { ROUTES } from '@/config';
import { useAllPresidents } from '@/core/hooks';
import { Icon } from '@/core/icon';
import {
  Button,
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
  CarouselScrollBar,
} from '@/core/ui';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const History = () => {
  const { i18n } = useTranslation();
  const { t } = useTranslation('translation');

  const { error, isLoading, presidents, historyPage } = useAllPresidents(i18n.language);

  if (error) {
    return <p>Oh no, there was an error</p>;
  }

  if (isLoading || !historyPage) {
    return <HistoryLoading />;
  }

  return (
    <div className='w-full h-full'>
      <Carousel>
        <CarouselContent>
          <CarouselItem className='pl-0 -mr-1'>
            <Slide1 data={historyPage.page.one} />
          </CarouselItem>
          <CarouselItem className='pl-0 -mr-1'>
            <Slide2 data={historyPage.page.two} />
          </CarouselItem>
          <CarouselItem className='pl-0 -mr-1'>
            <Slide3 title={`1914 - ${t('history.member.current')}`} presidents={presidents} />
          </CarouselItem>
        </CarouselContent>
        <CarouselNext className='!bg-transparent disabled:bg-transparent right-0 disabled:hidden'>
          <Icon name='CHEVRON_RIGHT' className='w-10 h-10' />
        </CarouselNext>
        <CarouselPrevious className='!bg-transparent disabled:bg-transparent left-0 disabled:hidden '>
          <Icon name='CHEVRON_LEFT' className='w-10 h-10' />
        </CarouselPrevious>
        <Link to={ROUTES.MAIN} className={'absolute z-10 top-14 right-20'}>
          <Button className='outline-none hover:bg-danger focus:bg-danger border-none flex px-7 py-8 bg-danger rounded-full items-center space-x-2'>
            <Icon className='h-5 w-5' name='CHEVRON_LEFT' />
            <Icon className='h-7 w-6' name='HOME' />
          </Button>
        </Link>
        <CarouselScrollBar />
      </Carousel>
    </div>
  );
};
export default History;
